import {convertObjectToGraphQLQueryString} from '../../utils/graphqlUtils'

export function getForAutoComplete (obj) {
  const query = `query{
    getAllProperties(data: ${convertObjectToGraphQLQueryString(obj)}){
      body{
        _id
        name
      }
      statusCode
      meta{
        total_documents
      }
      isSuccess
      errors{
        code
        message
        field
      }
    }
  }`
  return query
}